import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { getOperators } from "connect-api/enums/api/get-operators";

import { typedFetchNoImpersonate } from "~/api/typed-fetch";

const operatorsQueryOptions = {
  list: (enabled: boolean) =>
    queryOptions({
      queryKey: ["operators", "list"] as const,
      queryFn: enabled
        ? ({ signal }) => getOperators(typedFetchNoImpersonate, signal)
        : skipToken,
    }),
};

function useOperators(enabled: boolean) {
  const query = useQuery(operatorsQueryOptions.list(enabled));

  return {
    operators: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { operatorsQueryOptions, useOperators };
